import type { Tag } from '@sats-group/ui-lib/react/tag/tag.types';
import type { ValueOf } from 'type-fest';

export const themes = {
  muted: 'muted',
} as const;

export type ClubLoadIndicator = {
  loadFactor?: {
    current?: number;
    max?: number;
  };
  loadTexts?: Record<string, string>;
  tagTheme?: Tag['theme'];
  theme?: ValueOf<typeof themes>;
};
